import { Divider, FormControlLabel, Switch } from "@mui/material";
import { theme as defaultTheme } from "@mindlercare/ui-web";
import { Typography } from "components/typography";
import {
  LocalSettingKey,
  getLocalSetting,
  isDevSettingsEnabled,
  setLocalSetting,
} from "core/localSettings";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${defaultTheme.SPACING.MD};
`;

export const LocalSettings = () => {
  const { t } = useTranslation();
  const [showDebugInfo, setShowDebugInfo] = useState(() =>
    getLocalSetting(LocalSettingKey.ShowDebugInfo),
  );
  const [showTranslationKeys, setShowTranslationKeys] = useState(() =>
    getLocalSetting(LocalSettingKey.ShowTranslationKeys),
  );

  const handleToggle = () => {
    const newValue = !showDebugInfo;
    setShowDebugInfo(newValue);
    setLocalSetting(LocalSettingKey.ShowDebugInfo, newValue);
  };

  const handleToggleTranslationKeys = () => {
    const newValue = !showTranslationKeys;
    setShowTranslationKeys(newValue);
    setLocalSetting(LocalSettingKey.ShowTranslationKeys, newValue);
  };

  return (
    <Container>
      <Typography insensitive variant="h3">
        {t("USER_SETTINGS.LOCAL_SETTINGS.SETTING_TITLE")}
      </Typography>
      <Typography insensitive variant="body" color="DARK_GREY">
        {t("USER_SETTINGS.LOCAL_SETTINGS.SETTING_DESCRIPTION")}
      </Typography>
      <FormControlLabel
        control={<Switch checked={showDebugInfo} onChange={handleToggle} />}
        label={t("USER_SETTINGS.LOCAL_SETTINGS.SHOW_DEBUG_INFO")}
      />
      {isDevSettingsEnabled && (
        <>
          <Divider />
          <Typography insensitive variant="h3">
            {t("USER_SETTINGS.DEV_SETTINGS.SETTING_TITLE")}
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={showTranslationKeys}
                onChange={handleToggleTranslationKeys}
              />
            }
            label={t("USER_SETTINGS.DEV_SETTINGS.SHOW_TRANSLATION_KEYS")}
          />
        </>
      )}
    </Container>
  );
};
